module.exports = __webpack_public_path__ + "img/fleche-tiret-2.43df5f58.png";